const routes = {
    name: 'Discounts',
    icon: 'mdi-laptop',
    path: '/reports/timhortons/discounts/',
    children: [
      {
        path: '/reports/timhortons/discounts/summary',
        name: 'Summary',
        component: () => import('./Summary.vue'),
        permissions: ['thSummary'],
      },
    ]
  };
  
  export default routes;